import {Text, View} from "react-native";
import * as React from "react";

export function Alert(props) {
    return <View style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-around",
        backgroundColor: "rgba(0,0,0, 0.4)",
        padding: 15,
        paddingLeft: 25,
        paddingRight: 25,
        borderRadius: 10
    }}>
        <Text style={{color: "white"}}>{props.children}</Text>
        {props.button}
    </View>;
}